module.exports = __webpack_public_path__ + "img/showgotover.a79189dd.png";